<template>
  <div class="sticky z-40 top-2 left-0 w-full px-[4vw]">
    <!-- <AppBannersFatClassic class="rounded overflow-hidden mb-2" /> -->
    <AppBannersFatDate class="rounded overflow-hidden mb-2" />
  </div>
</template>